export const getCheckoutItemsPendingAction = (state) => {
	state.isLoading = true;
	state.success = undefined;
};
